import { Typography } from "@mui/material";
import React from "react";

export default function Italics({ fontWeight, children }) {
  return (
    <Typography
      textAlign="center"
      fontStyle="italic"
      fontWeight={fontWeight ?? "medium"}
      sx={{ py: 1 }}
    >
      {children}
    </Typography>
  );
}
